export default {
  TitleReport: 'Tham số báo cáo',
  BudgetChapter: 'Chương',
  BudgetSource: 'Nguồn',
  BudgetKindItem: 'Khoản',
  IsInMonth: 'In tháng chỉnh lý quyết toán',
  IsVoucherAdjustment: 'Bao gồm chứng từ chỉnh lý quyết toán',
  ViewReport: 'Xem báo cáo',
  Cancel: 'Hủy',
  BudgetItemDetail: 'Tiết',
  ValidateBudgetItemTitle: 'Không hợp lệ',
  ValidateBudgetItemContent: 'Bạn cần chọn ít nhất một Mục từ danh sách.'
};